// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"149":"5aca3b986c8924ee485a","710":"f84600eb666d57da9d95"}[chunkId] + ".css";
};